import { changeOfDeviceMsg, changeOrderMsg, newOrderMsg, t } from '../../common/i18n';
import { formatTimestampToDDMMYYYY } from '../../common/utils/dateUtils';
import { CustomerOrderTopic } from '../../generated/api/customerOrderTopic';
import { CustomerOrderType } from '../../generated/api/customerOrderType';
import type { ChangeRequestDetails } from '../../generated/api/changeRequestDetails';
import type { CustomerOrder } from '../../generated/api/customerOrder';

export const getTopicText = (topic: CustomerOrderTopic): string => {
  switch (topic) {
    case CustomerOrderTopic.NEW_ORDER:
      return t.PTQ7(newOrderMsg);
    case CustomerOrderTopic.USER_CHANGE:
      return t.CAW5('User change');
    case CustomerOrderTopic.BILLING_ACCOUNT_CHANGE:
      return t.LMRW('Billing account change');
    case CustomerOrderTopic.ADDON_CHANGE:
      return t.FPYG('Changes to additional services');
    case CustomerOrderTopic.SUBSCRIPTION_TYPE_CHANGE:
      return t.QCG8('Subscription type change');
    case CustomerOrderTopic.SUBSCRIPTION_TERMINATION:
      return t.WWC5('Subscription termination');
    case CustomerOrderTopic.TEMPORARY_SUSPENSION:
      return t.FF9Q('Temporary suspension of subscription');
    case CustomerOrderTopic.RESUME_SUBSCRIPTION:
      return t.YG0B('Resume of suspended subscription');
    case CustomerOrderTopic.PHONE_NUMBER_CHANGE:
      return t.CZ6R('Change of phone number');
    case CustomerOrderTopic.SIM_CARD_ORDER:
      return t.QQGQ('SIM card order');
    case CustomerOrderTopic.DEVICE_CHANGE:
      return t.ZHBT(changeOfDeviceMsg);
    case CustomerOrderTopic.INSTALLATION_ADDRESS_CHANGE:
      return t.YPI7('Change of installation address');
    case CustomerOrderTopic.EPP_EXTENSION_PERIOD_CONTINUATION:
      return t.T3BS('Device as Service continues into extension period');
    case CustomerOrderTopic.EPP_EXTENSION_PERIOD_END:
      return t.N69Y('Device as Service contract ended');
    case CustomerOrderTopic.REDEEM_OF_DEVICE:
      return t.G09Z('Redeem of device');
    case CustomerOrderTopic.SERVICE_AGREEMENT_CHANGE:
      return t.FXBN('Service agreement change');
    case CustomerOrderTopic.SERVICE_CHARGE:
      return t.CU8T('Service charge');
    default:
      return 'Other';
  }
};

export const getCustomerOrderType = (customerOrderType?: CustomerOrderType): string => {
  if (customerOrderType === CustomerOrderType.CHANGE_REQUEST) {
    return t.PZ9O(changeOrderMsg);
  }
  return t.PTQ7(newOrderMsg);
};

export const isCustomerOrder = (customerOrder?: CustomerOrder): boolean =>
  Boolean(customerOrder && 'customerOrderId' in customerOrder);

export const isSfdcOrder = (orderId: string) => orderId.startsWith('CN');

export const getCustomerOrderId = (
  customerOrder?: CustomerOrder,
  changeRequestDetails?: ChangeRequestDetails
): string => {
  if (isCustomerOrder(customerOrder) && customerOrder) {
    return customerOrder.customerOrderDisplayId;
  }
  if (changeRequestDetails) {
    return changeRequestDetails.changeRequestId;
  }
  return '…';
};

export const getCustomerOrderHeadingBottom = (
  created?: number,
  changeRequestId?: string,
  companyName?: string
): string => {
  const formattedDate = formatTimestampToDDMMYYYY(created);
  const parts: string[] = [];

  if (changeRequestId) {
    parts.push(changeRequestId);
  }

  if (formattedDate) {
    parts.push(formattedDate);
  }

  if (companyName) {
    parts.push(companyName);
  }

  return parts.join(' | ');
};
